import { createApp } from 'vue'
import App from './App.vue'
import { createPinia } from "pinia";
import piniaPersist from 'pinia-plugin-persistedstate'
import router from './router'
import Varlet from '@varlet/ui';
import '@varlet/ui/es/style';
import { Themes, StyleProvider, Locale } from '@varlet/ui'
import { useLocale } from './hooks/useLocale';
import enUS from "@/locales/en-US";
import zhCN from '@/locales/zh-CN';
import Global from './utils/Global';
import Config from './utils/Config';
import SignalRService from './typescript/Services/SignalRService';
import { ColorEnum } from './utils/SuperEnum';
import Tools from './utils/Tools';
import { Vue3Marquee } from 'vue3-marquee'
import { useSystemConfigStore } from './store/SystemConfigStore';
import { useLocaleStore } from './store/locale';
import { MessageGroupTypeEnum } from './utils/MessageNoticeEnum';
import { TimeSync } from './utils/TimeSync';
import { fetchGetCurrentUtcTimestampAsync } from './typescript/Services/Api/GlobalApi';


const app = createApp(App);
app.component('Vue3Marquee', Vue3Marquee)
//#region 全局语言

app.config.globalProperties.$t = (path: string, params?: Record<string, string | number>) => {
    return useLocale().t(path, params)
}
//#endregion

//#region 初始化时间戳
TimeSync.init(fetchGetCurrentUtcTimestampAsync);
TimeSync.startPeriodicSync(fetchGetCurrentUtcTimestampAsync);
//#endregion

const pinia = createPinia();
pinia.use(piniaPersist);
app.use(pinia);
app.use(Varlet);
app.use(router);

app.config.globalProperties.$R = (url: string | null | undefined) => {
    return Global.GetResourceURL(url);
};


//获取系统配置
const systemConfigStore = useSystemConfigStore();


//#region  初始化语言
const localStore = useLocaleStore();

//#endregion

//#region 初始化语言
// Locale.add('en-US', Locale.enUS);
// Locale.add('zh-CN', Locale.zhCN);

//可进行语言覆盖
Locale.merge('en-US', {
    ...Locale.enUS,
    ...enUS
});

Locale.merge('zh-CN', {
    ...Locale.zhCN,
    ...zhCN
});

//#endregion


systemConfigStore.GetSystemConfigAsync().then(async resp => {
    if (resp.CheckIsOk()) {
        //初始化语言
        await localStore.LoadLanguageAsync();
        let languages = localStore.GetLanguageList;
        for (let i = 0; i < languages.length; i++) {
            const v = languages[i];
            const lCode = v.Code!.replace('-', '');
            let langModule = {};
            try {
                langModule = (await import(`@/locales/${v.Code}.ts`)).default;
                Tools.ShowLog("Locale", `加载语言成功:${v.Code}`, ColorEnum.Success);
            }
            catch (ex) {
                Tools.ShowLog("Locale", `加载语言失败:${v.Code}`, ColorEnum.Error);
            }
            let lanDefalut = (Locale as any)[lCode];
            if (lanDefalut == null)
                lanDefalut = Locale.enUS;

            Locale.add(v.Code!, {
                ...lanDefalut,
                ...langModule
            });
        }
        //#region 连接到服务
        SignalRService.Instance.StartAsync().then(async () => {
            Tools.ShowLog("SignalR", "已连接到服务", ColorEnum.Success);
            
            //#region 订阅系统
            SignalRService.Instance.JoinGroupAsync(MessageGroupTypeEnum.SYSTEM);
            //#endregion

            app.mount('#app');
        });
        //#endregion 
    }
});